import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-paper" data-id="element-78" data-mp="1lb91qzhuxkk4">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-79" data-mp="1lcabn0n50109">
        <div className="mx-auto max-w-2xl text-center" data-id="element-80" data-mp="1gdqpp08jmp7w">
          <p className="eyebrow flex items-center justify-center gap-2.5 text-[10px] text-clay sm:text-[11px]" data-id="element-81" data-mp="1gauuhjo2yen5">
            <span className="h-px w-6 bg-clay/50" aria-hidden="true" data-id="element-82" data-mp="291mkfzejy721" />
            Preguntas frecuentes
            <span className="h-px w-6 bg-clay/50" aria-hidden="true" data-id="element-83" data-mp="24207lr2mystr" />
          </p>
          <h2 className="mt-4 text-[31px] font-semibold leading-[1.1] tracking-[-0.015em] text-ink sm:text-[42px] lg:text-[48px]" data-id="element-84" data-mp="1z374mskz6k7u">
            ¿Todavía tenés <span className="text-clay" data-id="element-85" data-mp="snwe0lzyn6p8">dudas</span>?
          </h2>
        </div>

        <ul className="mx-auto mt-12 max-w-3xl sm:mt-14" data-id="element-86" data-mp="nnqtdps3ykgn">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="border-b border-sage-line" data-id="element-87" data-mp="pfv1k89pwubz" data-mpi={index}>
                <h3 data-id="element-88" data-mp="ugiqmoedz13k">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-6 text-left" data-id="element-89" data-mp="uey6zttm12kh">
                    <span className={`font-display text-[16.5px] font-semibold leading-snug transition-colors duration-150 ease-out sm:text-[19px] ${isOpen ? 'text-clay' : 'text-ink'}`} data-id="element-90" data-mp="6rq4fjnkg7m5">
                      {faq.question}
                    </span>
                    <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage-tint" aria-hidden="true" data-id="element-91" data-mp="3t07v0ak8ps7e">
                      {isOpen ? <MinusIcon className="h-4 w-4 text-sage-deep" data-id="element-92" data-mp="3jy8d7g1eik3e" /> : <PlusIcon className="h-4 w-4 text-sage-deep" data-id="element-93" data-mp="3jyhzotn8m94c" />}
                    </span>
                  </button>
                </h3>
                {isOpen ? <div id={`faq-panel-${index}`} className="pb-7 pr-12" data-id="element-94" data-mp="1uhcr3g99rw9k">
                    <p className="text-[14.5px] leading-[1.8] text-ink-soft sm:text-[16px]" data-id="element-95" data-mp="1uinx7mq6tg3u">
                      {faq.answer}
                    </p>
                  </div> : null}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}